import { useEffect } from "react";
import classNames from "classnames";
import { PopUp, Wrapper } from "./styles";
import { variantLoader } from "./variant-loader";
import useBreakpoints from "hooks/useBreakpoints";
import { LeftRightAnimation } from "theme/animations";
import { useAppDispatch, useAppSelector } from "hooks";
import { useInitialActions, useReportEventOnClose } from "./hooks";
import {
	onClosePopUp,
	onDIPtrigger,
	selectCommonState,
	selectPopUpManagerState
} from "redux/slices";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import { useLocation } from "react-router-dom";
import { useLinks } from "hooks/useLinks";

interface PopUpManagerProps {}

const PopUpManager: React.FC<PopUpManagerProps> = () => {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const { isSmDown } = useBreakpoints();
	const { variant } = useAppSelector(selectPopUpManagerState);
	const { tutorialSlideNumber } = useAppSelector(selectCommonState);
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const links = useLinks();
	useInitialActions();
	const report = useReportEventOnClose(variant);

	const getWindowSize = () => {
		const { innerHeight } = window;
		const vh = innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
	};

	useEffect(() => {
		getWindowSize();
	}, [window.innerHeight]);

	const isScalable = () => {
		if (
			variant === "drip-offer" ||
			variant === "drip-offer-reward" ||
			variant?.includes("drip-offer-info") ||
			variant === "endless-offer-reward-collected" ||
			variant === "daily-login-streak-loyalty-points" ||
			variant === "drip-offer-end" ||
			variant === "drip-offer-missed-event" ||
			variant === "bouncy-chest-reward-collected" ||
			variant?.includes("single-item-info") ||
			variant?.includes("cgg-purchase-success") ||
			variant?.includes("tutorial") ||
			variant === "loyalty-points-info" ||
			variant === "cgg-new-tier" ||
			variant === "cgg-event-completed" ||
			variant === "cgg-eligibility-tools" ||
			variant === "cgg-not-enough-club-members" ||
			variant === "cgg-not-yet-contributed" ||
			variant === "cgg-more-info" ||
			variant === "pb-pbftue-v2" ||
			variant === "pb-pbftue-v3" ||
			variant === "sign-up-incentive-reward" ||
			variant === "rewarding-deeplink-reward" ||
			variant?.includes("bundle-up") ||
			variant?.includes("rebate") ||
			variant === "daily-login-earned-reward" ||
			variant === "pb-reward-collected-v3" ||
			variant === "grant-reward-collected" ||
			variant === "loyalty-points-added" ||
			variant?.includes("pwa") ||
			variant === "pb-v3-select-event" ||
			variant === "pb-v3-rewards-uncollected" ||
			variant === "pb-v3-tier-complete" ||
			variant?.includes("pb-v3-club-change") ||
			variant === "pb-v3-cycle-complete" ||
			variant?.includes("friend-shop") ||
			variant?.includes("friend-invite") ||
			variant === "app-update-available" ||
			variant === "first-purchase"
		) {
			return true;
		}

		return false;
	};

	return variant ? (
		<PopUp
			isTutorialActive={
				tutorialSlideNumber === 3 && variant === "tutorial-loyalty-shop"
			}
			className={`${isScalable() && "scale"} ${
				variant === "tutorial" && "tutorial"
			}`}
		>
			<LeftRightAnimation
				enabled={variant === "tutorial-loyalty-shop" ? false : true}
			>
				<Wrapper className={classNames(isSmDown && "mobile")}>
					{variantLoader(variant)}
					{!isScalable() && (
						<CloseIconButton
							onClose={() => {
								// Workaround: Popup does not support adding functionality in each variant on close
								if (location.pathname === links.free_daily_gifts.path) {
									dispatch(onDIPtrigger({ triggerType: "collectDailyGift" }));
								}
								//
								dispatch(onClosePopUp());
								if (typeof report !== "undefined") {
									reportEvent(report["name"], {
										...report["opts"]
									});
									reportPlaygamiEvent("tp.web_frontend", {
										...report["opts"]
									});
								}
							}}
						/>
					)}
				</Wrapper>
			</LeftRightAnimation>
		</PopUp>
	) : null;
};

export default PopUpManager;
